import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const SelectionSoundType = (props) => {
	const { name, value, setSoundTypes, disabled } = props;
	const { t } = useTranslation('translation', { keyPrefix: 'manageVehiclesPage.fleetConfigurationContainer.editProfile.selectionSoundType' });

	const setNewValue = (e) => {
		setSoundTypes(name, e.target.value)
	}

	return (
		<div className="toggle-wrapper">
			<label className="settings-title">{t('eventAudio')}</label>
			<select
				placeholder="select"
				className="form-control rosco-select mini inline"
				name={name}
				value={value}
				onChange={setNewValue}
				disabled={disabled}
			>
				<option value="0">{t('disableAudio')}</option>
				<option value="1">{t('eventVoicePrompt')}</option>
				<option value="2">{t('eventChime')}</option>
			</select>
		</div>
	)
}

export default SelectionSoundType;
